import React, { useState, useRef } from 'react';
import toast from "react-hot-toast";
import { useDispatch } from 'react-redux';
import { Helpers } from '../../../helpers/Helpers';
import { GetWelcomeListByAntrepoOfferIdResponseData } from '../../../models/response/welcome/GetWelcomeListByAntrepoOfferIdResponse';
import { storeAreYouSureModalCallback } from '../../../redux/reducers/authSlice';
import { VehicleService } from '../../../services/VehicleService';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import Box from '../../Box';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../CustomSingleSelect';
import CustomTextInput from '../../CustomTextInput';

interface Props {
    selectedVehicle: CustomSingleSelectModel | undefined
    vehicleDetails: GetWelcomeListByAntrepoOfferIdResponseData[]
    setVehicleDetails: React.Dispatch<React.SetStateAction<GetWelcomeListByAntrepoOfferIdResponseData[]>>
    selectedTrailer: CustomSingleSelectModel | undefined
    antrepoIncomingDate: string | undefined
    containerNo: string | undefined
    setSelectedVehicle: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setSelectedTrailer: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setContainerNo: React.Dispatch<React.SetStateAction<string | undefined>>
    setAntrepoIncomingDate: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedSupplier: CustomSingleSelectModel | undefined
    selectedDriver: CustomSingleSelectModel | undefined
    saveVehicleOrTrailer: (_insertedValue: string, _isVehicle: number, _isTrailer: number, _setFunction: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>) => Promise<void>
}

const CommonWelcomeVehicleDetails = ({
    selectedVehicle,
    vehicleDetails,
    setVehicleDetails,
    selectedTrailer,
    antrepoIncomingDate,
    containerNo,
    setSelectedVehicle,
    setSelectedTrailer,
    setContainerNo,
    setAntrepoIncomingDate,
    selectedSupplier,
    selectedDriver,
    saveVehicleOrTrailer
}: Props) => {
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const vehicleDetailsRef: any = useRef();
    const [welcomeId, setWelcomeId] = useState<string | undefined | null>(undefined);

    const setItemSelected = (_id: string) => {
        setVehicleDetails(vehicleDetails.map(function (x) {
            if (x.welcomeId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const saveItem = () => {
        if (Helpers.isEmpty(antrepoIncomingDate)) {
            toast.error('Antrepoya Gelecek Tarih alanını doldurunuz!')
        }
        else {
            if (Helpers.isEmpty(welcomeId)) {
                var o: GetWelcomeListByAntrepoOfferIdResponseData = {
                    welcomeId: Helpers.generateUUID(true),
                    isSelected: false,
                    vehicleId: selectedVehicle?.value,
                    vehicleName: selectedVehicle?.label,
                    trailerId: selectedTrailer?.value,
                    trailerName: selectedTrailer?.label,
                    containerNo: containerNo,
                    antrepoIncomingDate: antrepoIncomingDate,
                    antrepoIncomingDateStr: Helpers.dateParser(antrepoIncomingDate, true),
                    groupNo: (vehicleDetails.length == 0 ? 1 : Math.max(...vehicleDetails.filter(x => x.groupNo && x.groupNo.toString().trim() != '').map(x => parseInt(x.groupNo + ''))) + 1).toString()
                }

                setVehicleDetails([...vehicleDetails, o])
            }
            else {
                setVehicleDetails(vehicleDetails.map(function (x) {
                    if (x.welcomeId == welcomeId) {
                        x.isSelected = false;
                        x.vehicleId = selectedVehicle?.value;
                        x.vehicleName = selectedVehicle?.label;
                        x.trailerId = selectedTrailer?.value;
                        x.trailerName = selectedTrailer?.label;
                        x.containerNo = containerNo;
                        x.antrepoIncomingDate = antrepoIncomingDate;
                        x.antrepoIncomingDateStr = Helpers.dateParser(antrepoIncomingDate, true);
                        x.groupNo = vehicleDetails.find(x => x.welcomeId == welcomeId)?.groupNo
                    }

                    return x;
                }))
            }

            setWelcomeId('');
            setSelectedVehicle(undefined);
            setSelectedTrailer(undefined);
            setContainerNo('');
            setAntrepoIncomingDate('');
            setIsOpen(false);
            scrollTo();
        }
    }

    const deleteItems = () => {
        setVehicleDetails(vehicleDetails.filter(x => !x.isSelected));
    }

    const selectAll = () => {
        var isAllSelected = vehicleDetails.filter(x => (!x.ledgerNo || x.ledgerNo == '-')).length == vehicleDetails.filter(x => (!x.ledgerNo || x.ledgerNo == '-') && x.isSelected).length;

        setVehicleDetails(vehicleDetails.map(function (x) {
            if ((!x.ledgerNo || x.ledgerNo == '-'))
                x.isSelected = !isAllSelected;

            return x;
        }))
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setWelcomeId('');
        setSelectedVehicle(undefined);
        setSelectedTrailer(undefined);
        setContainerNo('');
        setAntrepoIncomingDate('');
        setIsOpen(false);
        scrollTo();
    }

    const setUpdateItem = () => {
        var o = vehicleDetails.filter(x => x.isSelected)[0];

        setWelcomeId(o.welcomeId);
        setSelectedVehicle(o.vehicleId ? { label: o.vehicleName, value: o.vehicleId } : undefined);
        setSelectedTrailer(o.trailerId ? { label: o.trailerName, value: o.trailerId } : undefined);
        setContainerNo(o.containerNo);
        setAntrepoIncomingDate(o.antrepoIncomingDate);
        setIsOpen(true);
        scrollTo();
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = vehicleDetailsRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    return (
        <div ref={vehicleDetailsRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Araç Bilgileri</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Araç Plaka</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedVehicle}
                                                onChange={setSelectedVehicle}
                                                onMenuOpen={() => VehicleService.getVehicleList(["2", "4", "5"])}
                                                insertable={(selectedSupplier && selectedDriver && !selectedVehicle) ? {
                                                    onSubmit: {
                                                        onSubmit: (_insertedValue) => {
                                                            saveVehicleOrTrailer(_insertedValue, 1, 0, setSelectedVehicle);
                                                        }
                                                    }
                                                } : undefined}
                                                labelName='plate'
                                                valueName='vehicleId'
                                            />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Antrepoya Gelecek Tarih</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={antrepoIncomingDate} onChange={(e) => setAntrepoIncomingDate(e.target.value)} type="datetime-local" className="form-control form-control-solid" />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Dorse Plaka</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedTrailer}
                                                onChange={setSelectedTrailer}
                                                onMenuOpen={() => VehicleService.getVehicleList(["6", "7"])}
                                                insertable={(selectedSupplier && selectedDriver && !selectedTrailer) ? {
                                                    onSubmit: {
                                                        onSubmit: (_insertedValue) => {
                                                            saveVehicleOrTrailer(_insertedValue, 0, 1, setSelectedTrailer);
                                                        }
                                                    }
                                                } : undefined}
                                                labelName='plate'
                                                valueName='vehicleId'
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Konteyner No</label>
                                            <CustomTextInput value={containerNo} setValue={setContainerNo} />
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} opacity={"1"} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={vehicleDetails.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={vehicleDetails.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>

                        <Box onClick={vehicleDetails.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={vehicleDetails.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={vehicleDetails.filter(x => x.isSelected).length > 0 && vehicleDetails.filter(x => x.isSelected).length == vehicleDetails.filter(x => (!x.ledgerNo || x.ledgerNo == '-')).length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Grup No</th>
                                            <th>Araç / Dorse</th>
                                            <th>Konteyner No</th>
                                            <th>Antrepoya Gelecek Tarih</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            vehicleDetails.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            vehicleDetails.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        {
                                                            ((!item.ledgerNo || item.ledgerNo == "-")) && (
                                                                <div className='d-flex'>
                                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                        <input onChange={() => setItemSelected(item.welcomeId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                    </label>
                                                                </div>
                                                            )
                                                        }
                                                    </td>
                                                    <td>{item.groupNo}</td>
                                                    <td>{item.vehicleName ?? '-'} / {item.trailerName ?? '-'}</td>
                                                    <td>{item.containerNo}</td>
                                                    <td>{item.antrepoIncomingDateStr}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default CommonWelcomeVehicleDetails;